import { render, staticRenderFns } from "./Deactivated.vue?vue&type=template&id=3c685f74&"
import script from "./Deactivated.vue?vue&type=script&lang=js&"
export * from "./Deactivated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports